import { ExportReportType } from '~/exportReport/exportReportType';
import { ExportReportLocationPrintPageComponent } from '~/exportReport/printPage/exportReportLocationPrintPage.component';
import { useToolsStateExportReportSelector } from '~/store/mapSettings/toolsState/exportReport/exportReportToolState.selectors';

export const ExportReportPrintPageContainer = () => {
  const exportReportState = useToolsStateExportReportSelector();

  if (!exportReportState.isActive) {
    return null;
  }

  if (exportReportState.params.type === ExportReportType.Location) {
    return (
      <ExportReportLocationPrintPageComponent
        params={exportReportState.params}
        template={exportReportState.template}
      />
    );
  }

  return null;
};
